// For SSR
export { default, getServerSideProps } from './[...path]';

// For SSG
// export { default, getStaticProps } from './[...path]';
